/**
 * Merged cart.js (Cart Page / Online Store 2.0)
 * - Mystery Box promo: adds random gift variants when product 7936843776074 is increased
 *   -> Uses a sessionStorage-backed pool to avoid duplicates until pool exhausted
 * - Kickoff promo: manages a specific gift variant (42635282350154) based on cart contents
 * - Unified cart-items, cart-remove-button, cart-note (no duplicate customElements)
 *
 * Assumptions:
 * - Theme provides: routes (cart_url, cart_change_url, cart_update_url), fetchConfig(),
 *   publish(), subscribe(), PUB_SUB_EVENTS, trapFocus(), window.cartStrings
 */

(() => {
  /* ============================
     CONFIG
     ============================ */
  const MYSTERY_TARGET_PRODUCT_ID = 7936843776074;
  
  // Gift variant IDs - ye gifts add hon gay jab mystery box increase hoga
  const MYSTERY_GIFT_VARIANT_IDS = {
    adults: [
      43122416058442,
      43122416091210,
      43122416123978,
      43122416156746,
      43122416189514,
      43122416222282
    ],
    kids: [
      43125036089418,
      43125036122186,
      43125036154954,
      43125036187722,
      43125036220490,
      43125036253258,
      43122416287818
    ]
  };

  // Helper function to detect type from variant ID
  function getTypeFromVariantId(variantId) {
    const vid = parseInt(variantId);
    if (MYSTERY_GIFT_VARIANT_IDS.kids.includes(vid)) return 'kids';
    if (MYSTERY_GIFT_VARIANT_IDS.adults.includes(vid)) return 'adults';
    return null;
  }

// Keys for sessionStorage per type
const MYSTERY_POOL_KEY_KIDS = 'giftVariantPool_kids';
const MYSTERY_POOL_KEY_ADULTS = 'giftVariantPool_adults';

  const KICKOFF_GIFT_VARIANT_ID = 426352823501540000; // fixed kickoff gift variant
// const KICKOFF_GIFT_VARIANT_ID = 123456789;
  const ON_CHANGE_DEBOUNCE_TIMER = 300;

  /* ============================
     UTILITIES
     ============================ */
  function debounce(fn, delay) {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => fn(...args), delay);
    };
  }

  function sleep(ms) {
    return new Promise((res) => setTimeout(res, ms));
  }

  // Safe CSS.escape fallback if not available
  function escapeForSelector(s) {
    if (window.CSS && CSS.escape) return CSS.escape(s);
    return s.replace(/([ #;?%&,.+*~\':"!^$[\]()=>|\/@])/g, '\\$1');
  }

  /* ============================
     MYSTERY POOL (module-level)
     - Keep a single in-memory pool and keep in sync with sessionStorage.
     - This prevents duplication across quick successive calls.
     ============================ */
  let mysteryPools = { kids: null, adults: null };

  function loadMysteryPool(type) {
  if (!type || !MYSTERY_GIFT_VARIANT_IDS[type]) {
    console.warn('loadMysteryPool called with invalid type:', type);
    return [];
  }
  if (mysteryPools[type]) return mysteryPools[type];

  try {
    const raw = sessionStorage.getItem(type === 'kids' ? MYSTERY_POOL_KEY_KIDS : MYSTERY_POOL_KEY_ADULTS);
    if (raw) {
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed) && parsed.length > 0) {
        mysteryPools[type] = parsed.slice();
        return mysteryPools[type];
      }
    }
  } catch (e) {}
  mysteryPools[type] = MYSTERY_GIFT_VARIANT_IDS[type].slice();
    saveMysteryPool(type);
    return mysteryPools[type];
  }


  function saveMysteryPool(type) {
    try {
      sessionStorage.setItem(
        type === 'kids' ? MYSTERY_POOL_KEY_KIDS : MYSTERY_POOL_KEY_ADULTS,
        JSON.stringify(mysteryPools[type])
      );
    } catch (e) {}
  }

 
    
// function getUsedGiftsFromCart(cartItems) {
//   return cartItems
//     .filter((item) => MYSTERY_GIFT_VARIANT_IDS.includes(item.id))
//     .map((item) => item.id);
// }
 function getNextMysteryVariant(type) {
    loadMysteryPool(type);
    if (!Array.isArray(mysteryPools[type]) || mysteryPools[type].length === 0) {
      mysteryPools[type] = MYSTERY_GIFT_VARIANT_IDS[type].slice();
    }
    const idx = Math.floor(Math.random() * mysteryPools[type].length);
    const selected = mysteryPools[type].splice(idx, 1)[0];
    saveMysteryPool(type);
    return selected;
  }

  // Optional helper to reset the pool (exposed later)
  function resetMysteryPool() {
    mysteryPool = MYSTERY_GIFT_VARIANT_IDS.slice();
    saveMysteryPool();
  }

  /* ============================
     LOADER HELPERS
     ============================ */
  function showCartLoader() {
    const loader = document.getElementById('custom-loader-cart');
    if (loader) loader.classList.remove('d-none');
  }
  function hideCartLoader() {
    const loader = document.getElementById('custom-loader-cart');
    if (loader) loader.classList.add('d-none');
  }

  /* ============================
     USER-REMOVED FLAG (kickoff)
     - kept on window so other scripts can modify if needed
     ============================ */
  if (typeof window.userRemovedGift === 'undefined') window.userRemovedGift = false;

  /* ============================
     CUSTOM ELEMENTS: cart-remove-button
     (guard against duplicate definitions)
     ============================ */
  if (!customElements.get('cart-remove-button')) {
    class CartRemoveButton extends HTMLElement {
      constructor() {
        super();
        this.addEventListener('click', (event) => {
          // show loader then perform default behavior
          showCartLoader();
          event.preventDefault();
          const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
          cartItems.updateQuantity(this.dataset.key, this.dataset.index, 0);
        });
      }
    }
    customElements.define('cart-remove-button', CartRemoveButton);
  }

  /* ============================
     Unified cart-items (merges both scripts' behaviors)
     ============================ */
  if (!customElements.get('cart-items')) {
    class CartItems extends HTMLElement {
      constructor() {
        super();

        this.lineItemStatusElement =
          document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

        const debouncedOnChange = debounce((event) => {
          this.onChange(event);
        }, ON_CHANGE_DEBOUNCE_TIMER);

        this.addEventListener('change', debouncedOnChange.bind(this));

        // ensure pool is loaded into memory
        loadMysteryPool('adults');
        loadMysteryPool('kids');
      }

      cartUpdateUnsubscriber = undefined;

      connectedCallback() {
        // subscribe to pub/sub (if available)
        try {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
            if (event.source === 'cart-items') return;
            this.onCartUpdate();
          });
        } catch (e) {
          // subscribe might not be present in some themes; ignore
        }
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
      }

      onChange(event) {
        // Pass along dataset values (productId may be on some templates)
        this.updateQuantity(
          event.target.dataset.key,
          event.target.dataset.index,
          event.target.value,
          document.activeElement.getAttribute('name'),
          event.target.dataset.quantityVariantId,
          event.target.dataset.productId
        );
        
          showCartLoader();
      }

      onCartUpdate() {
        // Re-fetch cart sections depending on whether this is drawer or main cart.
        if (this.tagName === 'CART-DRAWER-ITEMS') {
          fetch(`${routes.cart_url}?section_id=cart-drawer`)
            .then((r) => r.text())
            .then((text) => {
              const html = new DOMParser().parseFromString(text, 'text/html');
              const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
              selectors.forEach((selector) => {
                const target = document.querySelector(selector);
                const source = html.querySelector(selector);
                if (target && source) target.replaceWith(source);
              });
            })
            .catch((e) => console.error(e));
        } else {
          // cart page main items
          fetch(`${routes.cart_url}?section_id=main-cart-items`)
            .then((r) => r.text())
            .then((text) => {
              const html = new DOMParser().parseFromString(text, 'text/html');
              const source = html.querySelector('cart-items');
              if (source) this.innerHTML = source.innerHTML;
            })
            .catch((e) => console.error(e));
        }
      }

      getSectionsToRender() {
        return [
          {
            id: 'main-cart-items',
            section: document.getElementById('main-cart-items').dataset.id,
            selector: '.js-contents',
          },
          {
            id: 'cart-icon-bubble',
            section: 'cart-icon-bubble',
            selector: '.shopify-section',
          },
          {
            id: 'cart-live-region-text',
            section: 'cart-live-region-text',
            selector: '.shopify-section',
          },
          {
            id: 'main-cart-footer',
            section: document.getElementById('main-cart-footer').dataset.id,
            selector: '.js-contents',
          },
        ];
      }

      /**
       * updateQuantity - main entry point for changes from inputs and remove buttons
       * - If the productId matches the mystery target and quantity increased: add random gifts
       * - Otherwise: do a normal cart change
       */
      updateQuantity(key, line, quantity, name, variantId, productId) {
        const itemKeyParts = key.split(':');
        itemKeyParts.splice(1, 0, '\\:');
        const formattedKey = itemKeyParts.join('');

        this.enableLoading(formattedKey);

        const quantityElement =
          document.getElementById(`Quantity-${key}`) || document.getElementById(`Drawer-quantity-${key}`);
        const currentQty = quantityElement ? parseInt(quantityElement.getAttribute('value')) : 0;
        const newQty = parseInt(quantity);

        // Mystery target product logic: when quantity increases, add mystery gifts
        if (productId && parseInt(productId) === MYSTERY_TARGET_PRODUCT_ID && newQty > currentQty) {
          this.handleMysteryAddition(key, currentQty, newQty, quantityElement, formattedKey, name, variantId).catch((err) => {
            console.error('Mystery addition failed', err);
            // fallback: perform normal update to avoid leaving loading state
            this.performNormalUpdate(key, quantity, quantityElement, formattedKey, name, variantId);
          });
          return;
        }

        // Default: normal update
        this.performNormalUpdate(key, quantity, quantityElement, formattedKey, name, variantId);
      }

      // Handles adding random mystery gift variants when target product quantity increases
       async handleMysteryAddition(key, currentQty, newQty, quantityElement, formattedKey, name, variantId) {
          try {
            const delta = newQty - currentQty;
            if (delta <= 0) return;

            showCartLoader();

            // Fetch latest cart
            const cart = await fetch('/cart.js').then(r => r.json());

            // Find this item in cart by KEY (not just any item)
            const cartItem = cart.items.find(item => item.key === key);

            // Determine type - check cart item's variant_id against gift arrays
            let type = 'adults'; // default fallback
            
            if (cartItem) {
              const itemVariantId = parseInt(cartItem.variant_id);
              
              // Check if this variant belongs to kids or adults
              const detectedType = getTypeFromVariantId(itemVariantId);
              if (detectedType) {
                type = detectedType;
              } else {
                // Fallback: Check variant_title for keywords
                const variantTitle = (cartItem.variant_title || '').toLowerCase();
                
                if (variantTitle.includes('kid') || variantTitle.includes('child')) {
                  type = 'kids';
                } else if (variantTitle.includes('adult')) {
                  type = 'adults';
                }
              }
            }

            // Load pool for this type
            loadMysteryPool(type);

            // Get all gift variant IDs that are already in cart for THIS type only
            const usedGiftsInCart = cart.items
              .filter(item => MYSTERY_GIFT_VARIANT_IDS[type].includes(item.id))
              .map(item => item.id);

            // Remove already-used gifts from pool (no duplicates until pool exhausted)
            mysteryPools[type] = mysteryPools[type].filter(id => !usedGiftsInCart.includes(id));

            // If pool is empty after filtering, reset it (duplicates allowed now since all used)
            if (mysteryPools[type].length === 0) {
              mysteryPools[type] = MYSTERY_GIFT_VARIANT_IDS[type].slice();
            }
            saveMysteryPool(type);

            // Track variants we're adding in this batch to avoid duplicates within same operation
            const addedInThisBatch = [];

            // Add gifts one by one
            for (let i = 0; i < delta; i++) {
              // Filter out variants added in this batch (prevent duplicates within same increase)
              let availablePool = mysteryPools[type].filter(id => !addedInThisBatch.includes(id));
              
              // If no variants left after filtering, reset pool for this batch
              if (availablePool.length === 0) {
                availablePool = MYSTERY_GIFT_VARIANT_IDS[type].slice().filter(id => !addedInThisBatch.includes(id));
                // If still empty (all used in this batch), allow duplicates
                if (availablePool.length === 0) {
                  availablePool = MYSTERY_GIFT_VARIANT_IDS[type].slice();
                }
              }

              const idx = Math.floor(Math.random() * availablePool.length);
              const giftVariantId = availablePool[idx];
              
              // Remove from main pool if present
              const poolIdx = mysteryPools[type].indexOf(giftVariantId);
              if (poolIdx > -1) {
                mysteryPools[type].splice(poolIdx, 1);
              }
              
              // Track that we added this variant
              addedInThisBatch.push(giftVariantId);
              saveMysteryPool(type);

              await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  id: giftVariantId,
                  quantity: 1,
                }),
              });
            }

            // Update quantity visually
            if (quantityElement) quantityElement.value = newQty;

            // Refresh cart DOM based on whether we're in drawer or cart page
            const isDrawer = this.tagName === 'CART-DRAWER-ITEMS';
            
            if (isDrawer) {
              // Refresh cart drawer sections
              await this.refreshCartDrawerSections();
            } else {
              // Refresh cart DOM and **wait for it**
              await new Promise((resolve) => {
                const cartItemsEl = document.querySelector('cart-items');
                if (cartItemsEl) {
                  const observer = new MutationObserver(() => {
                    observer.disconnect();
                    resolve();
                  });
                  observer.observe(cartItemsEl, { childList: true, subtree: true });
                  this.onCartUpdate();
                  // Timeout fallback in case observer doesn't fire
                  setTimeout(resolve, 2000);
                } else {
                  this.onCartUpdate();
                  resolve();
                }
              });
            }

          } catch (err) {
            console.error('handleMysteryAddition error:', err);
            this.performNormalUpdate(key, newQty, quantityElement, formattedKey, name, variantId);
          } finally {
            this.disableLoading(formattedKey);
            hideCartLoader();
          }
        }

      // Helper method to refresh cart drawer sections
      async refreshCartDrawerSections() {
        try {
          const response = await fetch(`${routes.cart_url}?section_id=cart-drawer`);
          const html = await response.text();
          const newDoc = new DOMParser().parseFromString(html, 'text/html');
          
          // Update cart drawer items content (not the element itself to preserve event listeners)
          const newCartDrawerItems = newDoc.querySelector('cart-drawer-items');
          const currentCartDrawerItems = document.querySelector('cart-drawer-items');
          if (newCartDrawerItems && currentCartDrawerItems) {
            currentCartDrawerItems.innerHTML = newCartDrawerItems.innerHTML;
          }
          
          // Also update the drawer footer if present
          const newDrawerFooter = newDoc.querySelector('.drawer__footer');
          const currentDrawerFooter = document.querySelector('.drawer__footer');
          if (newDrawerFooter && currentDrawerFooter) {
            currentDrawerFooter.innerHTML = newDrawerFooter.innerHTML;
          }
          
          // Update drawer header if present
          const newDrawerHeader = newDoc.querySelector('.drawer__header');
          const currentDrawerHeader = document.querySelector('.drawer__header');
          if (newDrawerHeader && currentDrawerHeader) {
            currentDrawerHeader.innerHTML = newDrawerHeader.innerHTML;
          }

          // Update cart icon bubble
          const bubbleResponse = await fetch(`${routes.cart_url}?section_id=cart-icon-bubble`);
          const bubbleHtml = await bubbleResponse.text();
          const bubbleDoc = new DOMParser().parseFromString(bubbleHtml, 'text/html');
          const newBubble = bubbleDoc.querySelector('.shopify-section');
          const oldBubble = document.getElementById('cart-icon-bubble');
          if (newBubble && oldBubble) {
            oldBubble.innerHTML = newBubble.innerHTML;
          }

          // Update drawer empty state
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer) {
            const cart = await fetch('/cart.js').then(r => r.json());
            const savedBy = cart.items.find(i => i.vendor === 'SavedBy');
            const itemCount = savedBy ? cart.item_count - 1 : cart.item_count;
            cartDrawer.classList.toggle('is-empty', itemCount === 0);
            
            // Also update cart-drawer-items empty class
            if (currentCartDrawerItems) {
              currentCartDrawerItems.classList.toggle('is-empty', itemCount === 0);
            }
          }
        } catch (err) {
          console.error('refreshCartDrawerSections error:', err);
        }
      }




      performNormalUpdate(key, quantity, quantityElement, formattedKey, name, variantId) {
        const body = JSON.stringify({
          id: key,
          quantity,
          sections: this.getSectionsToRender().map((s) => s.section),
          sections_url: window.location.pathname,
        });

        fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
          .then((response) => response.text())
          .then((state) => {
            const parsed = JSON.parse(state);

            // If quantityElement missing, attempt to find again
            if (!quantityElement) {
              quantityElement = document.getElementById(`Quantity-${key}`) || document.getElementById(`Drawer-quantity-${key}`);
            }

            if (parsed.errors) {
              if (quantityElement) quantityElement.value = quantityElement.getAttribute('value');
              this.updateLiveRegions(key, parsed.errors);
              return;
            }

            // SavedBy vendor filter (preserve original logic)
            const SavedBy = parsed.items.find((item) => item.vendor === 'SavedBy');
            let itemCount = parsed.item_count;
            let itemLength = parsed.items.length;
            if (SavedBy) {
              itemCount -= 1;
              itemLength -= 1;
            }

            // Toggle empty classes
            this.classList.toggle('is-empty', itemCount === 0);
            const cartDrawerWrapper = document.querySelector('cart-drawer');
            const cartFooter = document.getElementById('main-cart-footer');

            if (cartFooter) cartFooter.classList.toggle('is-empty', itemCount === 0);
            if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', itemCount === 0);

            // Update sections
            this.getSectionsToRender().forEach((section) => {
              const elementToReplace =
                document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
              elementToReplace.innerHTML = this.getSectionInnerHTML(parsed.sections[section.section], section.selector);
            });

            // Quantity validation messaging
            const updatedItem = parsed.items.find((item) => item.key === key);
            const updatedValue = updatedItem ? updatedItem.quantity : undefined;
            const items = document.querySelectorAll('.cart-item');

            let message = '';
            if (items.length === itemLength && updatedValue !== (quantityElement ? parseInt(quantityElement.value) : undefined)) {
              if (typeof updatedValue === 'undefined') {
                message = window.cartStrings.error;
              } else {
                message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
              }
            }
            this.updateLiveRegions(key, message);

            // Focus management (trap focus if drawer)
            const lineItem = document.getElementById(`CartItem-${key}`) || document.getElementById(`CartDrawer-Item-${key}`);
            if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
              cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
            } else if (itemCount === 0 && cartDrawerWrapper) {
              trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
            } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
              trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
            }

            // Publish event for kickoff / other listeners
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsed, variantId });
          })
          .catch((err) => {
            console.error('Cart update error', err);
            this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
            const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
            if (errors) errors.textContent = window.cartStrings.error;
          })
          .finally(() => {
            this.disableLoading(formattedKey);
          });
      }

      updateLiveRegions(key, message) {
        const lineItemError =
          document.getElementById(`Line-item-error-${key}`) || document.getElementById(`CartDrawer-LineItemError-${key}`);
        if (lineItemError) {
          const el = lineItemError.querySelector('.cart-item__error-text');
          if (el) el.innerHTML = message;
        }

        if (this.lineItemStatusElement) this.lineItemStatusElement.setAttribute('aria-hidden', true);

        const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
        if (cartStatus) {
          cartStatus.setAttribute('aria-hidden', false);
          setTimeout(() => cartStatus.setAttribute('aria-hidden', true), 1000);
        }
      }

      getSectionInnerHTML(html, selector) {
        const parsed = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
        return parsed ? parsed.innerHTML : '';
      }

      enableLoading(key) {
        const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
        if (mainCartItems) mainCartItems.classList.add('cart__items--disabled');

        const cartItemElements = this.querySelectorAll(`#CartItem-${key} .loading-overlay`);
        const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${key} .loading-overlay`);
        [...cartItemElements, ...cartDrawerItemElements].forEach((ov) => ov.classList.remove('hidden'));

        try {
          document.activeElement.blur();
        } catch (e) {}

        if (this.lineItemStatusElement) this.lineItemStatusElement.setAttribute('aria-hidden', false);
      }

      disableLoading(key) {
        const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
        if (mainCartItems) mainCartItems.classList.remove('cart__items--disabled');

        const cartItemElements = this.querySelectorAll(`#CartItem-${key} .loading-overlay`);
        const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${key} .loading-overlay`);
        cartItemElements.forEach((ov) => ov.classList.add('hidden'));
        cartDrawerItemElements.forEach((ov) => ov.classList.add('hidden'));
      }
    }

    customElements.define('cart-items', CartItems);
  }

  /* ============================
     cart-note element (guarded)
     ============================ */
  if (!customElements.get('cart-note')) {
    customElements.define(
      'cart-note',
      class CartNote extends HTMLElement {
        constructor() {
          super();
          this.addEventListener(
            'change',
            debounce((event) => {
              const body = JSON.stringify({ note: event.target.value });
              fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
            }, ON_CHANGE_DEBOUNCE_TIMER)
          );
        }
      }
    );
  }

  /* ============================
     KICKOFF PROMO LOGIC
     - Runs on initial load + on cart updates
     ============================ */

  // Add/remove/correct kickoff gift based on cart contents
  async function handleKickoffGift(cartData = null) {
    showCartLoader();
    try {
      const data = cartData || (await fetch('/cart.js').then((r) => r.json()));
      const hasEligibleItem = data.items.some(
  (item) => {
    const isEligible =
      (item.variant_title && item.variant_title.trim().startsWith('Non-Prescription')) ||
      (item.title && item.title.includes('Reading')) ||
      (item.title && item.title.includes('Sunglasses'));

    // Check if this eligible item's price (for one unit) is >= 40
    // Shopify returns price in cents
    const itemPrice = item.price || 0;
    return isEligible && (itemPrice / 100) >= 41;
  }
);

// console.log('Eligible item exists with price >= $41:', hasEligibleItem);
      // const hasEligibleItem = data.items.some(
      //   (item) =>
      //     (item.variant_title && item.variant_title.trim().startsWith('Non-Prescription')) ||
      //     (item.title && item.title.includes('Reading')) ||
      //     (item.title && item.title.includes('Sunglasses'))
      // );

      const giftItem = data.items.find((item) => item.id === KICKOFF_GIFT_VARIANT_ID);

      // If user removed gift manually, do not re-add until they requalify
      if (window.userRemovedGift && !giftItem) {
        if (!hasEligibleItem) window.userRemovedGift = false; // reset when user removes qualifying item
        return;
      }

      if (hasEligibleItem && !giftItem) {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: KICKOFF_GIFT_VARIANT_ID, quantity: 1 }] }),
        });
        await refreshCartSection();
      } else if (hasEligibleItem && giftItem && giftItem.quantity !== 1) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: giftItem.key, quantity: 1 }),
        });
        await refreshCartSection();
      } else if (!hasEligibleItem && giftItem) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: giftItem.key, quantity: 0 }),
        });
        await refreshCartSection();
      }
    } catch (err) {
      console.error('Kickoff gift logic error:', err);
    } finally {
      hideCartLoader();
    }
  }

  // Utility to refresh cart DOM sections (cart page)
  async function refreshCartSection() {
    try {
      const res = await fetch(window.location.pathname);
      if (!res.ok) return;
      const html = await res.text();
      const parser = new DOMParser();
      const newDoc = parser.parseFromString(html, 'text/html');

      const newCartItems = newDoc.querySelector('cart-items');
      const newFooter = newDoc.querySelector('#cart-footer');
      const newMainFooter = newDoc.querySelector('#main-cart-footer');

      if (newCartItems && document.querySelector('cart-items')) document.querySelector('cart-items').replaceWith(newCartItems);
      if (newFooter && document.querySelector('#cart-footer')) document.querySelector('#cart-footer').replaceWith(newFooter);
      if (newMainFooter && document.querySelector('#main-cart-footer')) document.querySelector('#main-cart-footer').replaceWith(newMainFooter);
    } catch (e) {
      console.error('refreshCartSection error', e);
    }
  }

  // Called when user explicitly removes the kickoff gift via UI
  function markKickoffGiftRemoved() {
    window.userRemovedGift = true;
  }

  // Click handler for .remove-gift-btn (kickoff original custom button)
  document.addEventListener('click', async (e) => {
    const t = e.target;
    if (!t) return;
    if (t.classList.contains('remove-gift-btn')) {
      e.preventDefault();
      const key = t.getAttribute('data-key');
      if (!key) return;
      t.textContent = 'Removing...';
      try {
        const resp = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 }),
        });
        const cart = await resp.json();
        window.userRemovedGift = true;

        // remove DOM row if present
        const escapedKey = escapeForSelector(key);
        const itemRow =
          document.querySelector(`#CartItem-${escapedKey}`) ||
          document.querySelector(`#CartDrawer-Item-${escapedKey}`) ||
          document.querySelector(`[data-key="${key}"]`);
        if (itemRow) itemRow.remove();

        // remove container containing .kick_off if present
        const kickOffDiv = document.querySelector('.kick_off');
        if (kickOffDiv) kickOffDiv.remove();

        // update count bubbles
        const countEls = document.querySelectorAll('.cart-count, .cart-count-bubble');
        countEls.forEach((el) => (el.textContent = cart.item_count));

        t.textContent = 'Removed';
      } catch (err) {
        console.error('Remove gift failed:', err);
        t.textContent = 'Try Again';
      }
    }
  });

  // Lock gift UI (disable direct quantity changes for kickoff gift and attach remove listeners)
  function lockKickoffGiftUI() {
    const giftRow =
      document.querySelector(`[data-variant-id="${KICKOFF_GIFT_VARIANT_ID}"]`) ||
      document.querySelector(`[data-key*="${KICKOFF_GIFT_VARIANT_ID}"]`);
    if (!giftRow) return;

    const qtyInput = giftRow.querySelector('input[name="updates[]"], .quantity__input');
    const removeBtn = giftRow.querySelector('cart-remove-button, .cart-remove-button');

    if (qtyInput) {
      qtyInput.disabled = true;
      qtyInput.value = 1;
    }

    if (removeBtn) {
      removeBtn.style.display = 'inline-flex';
      removeBtn.disabled = false;
      removeBtn.removeEventListener('click', markKickoffGiftRemoved);
      removeBtn.addEventListener('click', markKickoffGiftRemoved);
    }
  }

  const kickoffObserver = new MutationObserver(() => lockKickoffGiftUI());

  /* ============================
     INITIALIZATION
     ============================ */
  document.addEventListener('DOMContentLoaded', async () => {
    // Run kickoff logic once at load
    try {
      await handleKickoffGift();
    } catch (e) {
      console.error('Initial kickoff run error', e);
    }

    // Start observer to lock kickoff gift UI
    try {
      kickoffObserver.observe(document.body, { childList: true, subtree: true });
      lockKickoffGiftUI();
    } catch (e) {
      // ignore observer errors
    }
  });

  // Subscribe to cart updates so kickoff logic runs when cart changes
  try {
    subscribe(PUB_SUB_EVENTS.cartUpdate, async (event) => {
      // Allow kickoff to receive the cart data if provided
      try {
        await handleKickoffGift(event?.cartData);
      } catch (e) {
        console.error('kickoff handler on cartUpdate failed', e);
      }
      // Re-lock UI after updates
      lockKickoffGiftUI();
    });
  } catch (e) {
    // subscribe not available — ignore
  }

  /* ============================
     EXPOSURES: debug helpers
     ============================ */
  window.MergedCartHelpers = {
    resetMysteryPool,
    checkMysteryPool: () => {
      loadMysteryPool('adults');
      loadMysteryPool('kids');
      console.info('Mystery pool:', mysteryPool);
    },
    markKickoffGiftRemoved,
  };
})();
